module.exports = __webpack_public_path__ + "img/planta_17.33255594.png";